import { BonusEvent } from '@/models/bonusEvent';
import { useMemo } from 'react';

export function useImageGrid(events: BonusEvent[]) {
  const imagesToDisplay: BonusEvent[] = useMemo(() => {
    const images: BonusEvent[] = events?.slice(0, 6) || [];
    const imageCount: number = images.length;

    if (imageCount === 0) {
      return [];
    }

    const imagesForGrid = [];
    for (let i = 0; i < 6; i++) {
      imagesForGrid.push(images[i % imageCount]);
    }

    return imagesForGrid;
  }, [events]);

  return { images: imagesToDisplay };
}
